<template>
    <div>
        <transition name="fade" appear mode="out-in" appear-active-class="fade-enter-active">
            <b-tabs align="center" content-class="mt-0 mb-0" v-model="step" justified>
                <b-row>
                    <b-col>
                        <b-tab active v-on:click="changeStepperText(0)">
                            <template v-slot:title>
                                <strong>
                                    <span v-bind:id="'circle1' + selectedInvoiceId" class="circle">1</span>
                                    <span v-bind:id="'stepperText1' + selectedInvoiceId" class="stepperText on">{{$t('fmweb.factuur')}}</span>
                                </strong>
                            </template>
                            <InvoiceImage v-if="windowSize < 992" v-bind:selectedInvoiceId="selectedInvoiceId" 
                                    class="b-col-with-invoice-image mb-4 d-xs-block d-sm-block d-md-block d-lg-none"/>

                            <b-container class="mb-0 ml-0">
                                <b-row>
                                    <b-table-simple responsive style="width: 100%" class="d-none d-lg-block d-xl-block">
                                        <b-thead>
                                            <b-tr>
                                                <b-th>{{$t('fmweb.naam')}}</b-th>
                                                <b-th>{{$t('fmweb.waarde')}}</b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody>
                                            <b-tr>
                                                <b-td>{{$t('fmweb.documentid')}}</b-td>
                                                <b-td>{{ invoice.documentId }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('fmweb.factuurnummer')}}</b-td>
                                                <b-td>{{ invoice.invoiceNumber }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('fmweb.factuurdatum')}}</b-td>
                                                <b-td>{{ invoice.invoiceDate | date}}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('fmweb.relatienaam')}}</b-td>
                                                <b-td>{{ invoice.creditor.name }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('fmweb.omschrijving')}}</b-td>
                                                <b-td>{{ invoice.description }}</b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                    <div class="d-none d-lg-block d-xl-block">
                                        <div class="mb-3 d-flex justify-content-between">
                                            <b-button-group class="mb-3 d-flex justify-content-start">
                                                <b-button variant="secondary" v-on:click="goToPreviousInvoice">
                                                    <i class="fas fa-hand-point-left mr-2"></i>{{$t('fmweb.vorigeFactuur')}}
                                                </b-button>
                                                <b-button variant="secondary" v-on:click="goToNextInvoice">
                                                    {{$t('fmweb.volgendeFactuur')}}<i class="fas fa-hand-point-right ml-2"></i>
                                                </b-button>
                                            </b-button-group>

                                            <b-button class="white--text fmcolors mb-3 ml-2 d-none">
                                                <i class="fas fa-bookmark"/> {{$t('fmweb.opslaan')}}
                                            </b-button>

                                            <b-button class="white--text fmcolors d-none" size="sm" @click="step = 1" v-on:click="changeStepperText(1)" style="margin-left: 5px;">
                                                <i class="fa far fa-hand-point-right"/> {{$t('fmweb.volgendestap')}}
                                            </b-button>

                                            <!-- <AproveTable class="d-none" :selectedInvoiceId="selectedInvoiceId"/> -->
                                            <div class="mb-3 d-flex justify-content-end ml-2">
                                                <b-button class="white--text d-flex fmcolors align-items-center" value="false" :id="this.invoice.id" style="margin-left: 10px" v-on:click="approveInvoice">
                                                    <i class="fas fa-check mr-2"/> {{$t('fmweb.akkoord')}}
                                                </b-button>
                                                <b-checkbox class="d-flex align-items-center checkbox-autom" style="margin-left: -15px" v-model="swithAutomaticGoToNextInvoice" v-on:click="swithAutomaticGoToNextInvoice = !swithAutomaticGoToNextInvoice">{{$t('fmweb.automatisch')}}
                                                    <span class="ml-2"><i class="fas fa-question-circle fa-sm" @click="$bvModal.show('modal-according')"/></span></b-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-xs-block d-sm-block d-md-block d-lg-none">
                                        <div class="mb-3 d-flex justify-content-between">
                                            <b-button-group class="mb-3 justify-content-start">
                                                <b-button variant="secondary" v-on:click="goToPreviousInvoice">
                                                    <i class="fas fa-hand-point-left mr-2"></i>{{$t('fmweb.vorigeFactuur')}}
                                                </b-button>
                                                <b-button variant="secondary" v-on:click="goToNextInvoice">
                                                    {{$t('fmweb.volgendeFactuur')}}<i class="fas fa-hand-point-right ml-2"></i>
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                        <div class="mb-3 justify-content-end">
                                            <b-button class="white--text fmcolors justify-content-start" value="false" :id="this.invoice.id" v-on:click="approveInvoice">
                                                <i class="fas fa-check mr-2"/> {{$t('fmweb.akkoord')}}
                                            </b-button>
                                            <b-checkbox class="checkbox-autom justify-content-end" style="margin-left: -15px" v-model="swithAutomaticGoToNextInvoice" v-on:click="swithAutomaticGoToNextInvoice = !swithAutomaticGoToNextInvoice">{{$t('fmweb.automatisch')}}
                                                <span class="ml-2"><i class="fas fa-question-circle fa-sm" @click="$bvModal.show('modal-according')"/></span></b-checkbox>
                                        </div>
                                    </div>

                                </b-row>
                            </b-container>
                        </b-tab>

                        <b-tab  title-item-class="d-none" v-on:click="changeStepperText(1)">
                            <template v-slot:title>
                                <strong>
                                    <span v-bind:id="'circle2' + selectedInvoiceId" class="circle off">2</span>
                                    <span v-bind:id="'stepperText2' + selectedInvoiceId" class="stepperText">{{$t('fmweb.boekingsregels')}}</span>
                                </strong>
                            </template>
                            <b-container class="mb-3">
                                <b-row>
                                    <b-col>
                                        <BookingLineTable
                                                :selectedInvoiceId="selectedInvoiceId"/>

                                        <div style="margin-bottom: 10px; display: flex; justify-content: flex-end">
                                            <b-button class="white--text fmcolors" style="margin-left: 5px;">
                                                <i class="fas fa-bookmark"/> {{$t('fmweb.opslaan')}}
                                            </b-button>

                                            <b-button class="white--text fmcolors" @click="step = 2" v-on:click="changeStepperText(2)" style="margin-left: 5px;">
                                                <i class="far fa-hand-point-right"/> {{$t('fmweb.volgendestap')}}
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-tab>

                        <b-tab title-item-class="d-none" v-on:click="changeStepperText(2)">
                            <template v-slot:title>
                                <strong>
                                    <span v-bind:id="'circle3' + selectedInvoiceId" class="circle off">3</span>
                                    <span v-bind:id="'stepperText3' + selectedInvoiceId" class="stepperText">{{$t('fmweb.accordering')}}</span>
                                </strong>
                            </template>
                            <b-container class="mb-3">
                                <b-row>
                                    <b-col>
                                        <!-- <AproveTable :selectedInvoiceId="selectedInvoiceId"/> -->
                                        <div style="margin-bottom: 10px; display: flex; justify-content: flex-end">
                                            <b-checkbox v-model="swithAutomaticGoToNextInvoice" v-on:click="swithAutomaticGoToNextInvoice = !swithAutomaticGoToNextInvoice">{{$t('fmweb.automatisch')}}</b-checkbox>

                                            <i class="fas fa-question-circle" @click="$bvModal.show('modal-according')"/>

                                            <b-button class="white--text fmcolors" value="false" :id="this.invoice.id" style="margin-left: 10px;" v-on:click="approveInvoice">
                                                <i class="fas fa-check"/> {{$t('fmweb.akkoord')}}
                                            </b-button>
                                        </div>
                                        <div>
                                            <b-modal id="modal-according" title="FM Module">
                                                <p class="my-4">{{$t('fmweb.accorderingsnackbar')}}</p>
                                            </b-modal>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-tab>
                        <Comments v-bind:selectedInvoiceId="selectedInvoiceId"/>
                    </b-col>
                    <b-col v-if="windowSize >= 992" class="b-col-with-invoice-image px-3 d-none d-lg-block d-xl-block">
                        <InvoiceImage v-bind:selectedInvoiceId="selectedInvoiceId" />
                    </b-col>
                </b-row>
            </b-tabs>
        </transition>
    </div>
</template>

<script>
    import Comments from "@/components/fmwebapp/Comments";
    import InvoiceImage from "@/components/fmwebapp/InvoiceImage";
    import BookingLineTable from "@/components/fmwebapp/BookingLineTable";
    import { uuidMixin } from "@/mixins/uuidMixin";
    import $ from "jquery";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "FactuurDetails",
        mixins: [uuidMixin],
        props: {
            selectedInvoiceId: null,
            stepperId: String,
            row: null
        },
        components: {BookingLineTable, Comments, InvoiceImage},
        data() {
            return {
                swithAutomaticGoToNextInvoice: true,
                y: 'bottom',
                x: null,
                mode: '',
                timeout: 10000,
                step: 0,
                windowSize: $(window).width()                
            }
        },
        computed: {
            ...mapGetters('fmwebapp',['invoice', 'invoices']),
        },
        mounted() {
            this.changeStepperText(0);
        },
        methods: {
            ...mapActions('fmwebapp', ['all', 'find']),
            goToNextInvoice() {
                this.expandAdditionalInfo(this.invoice)
                this.$emit('nextInvoice', 'next')
            },
            goToPreviousInvoice() {
                this.expandAdditionalInfo(this.invoice)
                this.$emit('previousInvoice', 'previous')
            },
            approveInvoice() {
				this.$emit('invoiceApproval', this.row)
				this.setApproval(this.invoice)
                if (this.swithAutomaticGoToNextInvoice) {
					this.$emit('nextInvoice', 'nextWithApprove')
                }
            },
			setApproval(invoice) {
                this.$store.dispatch('fmwebapp/setApproval', invoice)
            },
            expandAdditionalInfo(row) {
                var invoicePatch = {
                    _showDetails: !row._showDetails
                }

                this.$store.commit('fmwebapp/update', {
                    resource: "invoices",
                    result: { ...row, ...invoicePatch }
                })                

                var rowData = `caretDown${row.documentId}`;
                this.changeCaretStyle(rowData, !row._showDetails);
            },            
            changeCaretStyle(dataa, opened) {
                if (!opened) {
                    $(`#${dataa}`).toggleClass('caretDownOpenAnimation');
                    $(`#${dataa}`).css({'transform': 'rotate(-180deg)'});
                } else {
                    $(`#${dataa}`).toggleClass('caretDownCloseAnimation');
                    $(`#${dataa}`).css({'transform': 'rotate(0deg)'});
                }
            },          
            changeStepperText: function(step) {
                this.step = step;
                if (this.step === 0) {
                    $(`#circle2${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#circle3${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#stepperText2${this.selectedInvoiceId}`).css("color", "gray")
                    $(`#stepperText3${this.selectedInvoiceId}`).css("color", "gray")

                    $(`#circle1${this.selectedInvoiceId}`).css("background-color", "#7abd59");
                    $(`#stepperText1${this.selectedInvoiceId}`).css("color", "black")
                } else if (this.step === 1) {
                    $(`#circle1${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#circle3${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#stepperText1${this.selectedInvoiceId}`).css("color", "gray")
                    $(`#stepperText3${this.selectedInvoiceId}`).css("color", "gray")

                    $(`#circle2${this.selectedInvoiceId}`).css("background-color", "#7abd59");
                    $(`#stepperText2${this.selectedInvoiceId}`).css("color", "black")
                } else {
                    $(`#circle1${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#circle2${this.selectedInvoiceId}`).css("background-color", "gray");
                    $(`#stepperText1${this.selectedInvoiceId}`).css("color", "gray")
                    $(`#stepperText2${this.selectedInvoiceId}`).css("color", "gray")

                    $(`#circle3${this.selectedInvoiceId}`).css("background-color", "#7abd59");
                    $(`#stepperText3${this.selectedInvoiceId}`).css("color", "black")
                }
            },
            onResize() {
                this.windowSize = $(window).width();
            }                      
        },
        created() {
            var vm = this;
            vm.find({
                resource: 'invoices',
                id: this.selectedInvoiceId
            });
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        },
    }
</script>

<style>
    .circle {
        border-radius: 50%;
        height: 24px;
        min-width: 24px;
        width: 24px;
        transition: .3s cubic-bezier(.25,.8,.25,1);
        font-size: .75rem;
        background-color: #7abd59;
        justify-content: center;
        display: inline-flex;
        align-items: center;
        align-content: center;
        color: white;
    }

    .off {
        background-color: gray;
    }

    .stepperText {
        display: block;
        color: gray;
    }

    .on {
        color: black;
    }

    .stepperText:hover {
        color: black;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        border-color: #fff #fff #dee2e6 !important;
    }

    .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
        border-color: #fff #fff #dee2e6 !important;
    }

    .v-stepper__step__step{
        background-color: #7abd59 !important;
    }

    .cols{
        padding: 0 0 0 10px !important;
    }

    .v-stepper__content{
        padding: 0 0 0 0 !important;
    }

    @media only screen and (max-width: 510px) {
        .v-stepper__content{
            padding: 0 !important;
        }

        .mb-3, .my-3 {
            margin-bottom: 0.25rem!important;
        }
    }

    @media (max-width: 390px) {
        .mb-3, .my-3 {
            margin-bottom: 0.25rem!important;
        }
    }    

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .v-expansion-panels {
        margin-top: 6px;    }

    .row {
        margin-right: -15px;
        margin-left: -15px;
        margin-top: 6px;
    } 

    .b-col-with-invoice-image {
        padding: 0;
    }         

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active{
        transition: opacity 2s;
    }

    .fade-leave-active{
        transition: opacity 2s;
        opacity: 0;
    }

    .checkbox-autom {
        opacity: 0;
    }
    .checkbox-autom:hover {
        opacity: 1;
    }
</style>